/* eslint-disable no-loss-of-precision */
import blank from '../../Blank/blankData'

import Chinw from '../../FacialLines/Chinw'
import ChinDoublechin from '../../FacialLines/ChinDoublechin'
import ChinSmallDoubleChin from '../../FacialLines/ChinSmallDoubleChin'
import ChinVertLine from '../../FacialLines/ChinVertLine'

const data = [
  blank,

  {
    id: 'Chinw',
    svg: Chinw,
    positioning: {
      pointNarrow: {
        y: 137.43051147460938,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 137.4086456298828,
        scaleX: 0.9,
      },
      pointWide: {
        y: 135.62107849121094,
        scaleX: 1,
      },
      roundNarrow: {
        y: 137.3389129638672,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 137.3462371826172,
        scaleX: 0.95,
      },
      roundWide: {
        y: 136.9989471435547,
        scaleX: 1,
      },
      squareNarrow: {
        y: 135.70440673828125,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 136.66763305664062,
        scaleX: 1,
      },
      squareWide: {
        y: 137.2422332763672,
        scaleX: 1,
      },
    },
  },

  {
    id: 'ChinDoublechin',
    svg: ChinDoublechin,
    positioning: {
      pointNarrow: {
        y: 132.8437042236328,
        scaleX: 1,
      },
      pointMedium: {
        y: 133.75355529785156,
        scaleX: 0.95,
      },
      pointWide: {
        y: 132.7014923095703,
        scaleX: 1,
      },
      roundNarrow: {
        y: 134.03662109375,
        scaleX: 1,
      },
      roundMedium: {
        y: 134.3433074951172,
        scaleX: 1,
      },
      roundWide: {
        y: 133.66140747070312,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 132.8467254638672,
        scaleX: 1,
      },
      squareMedium: {
        y: 133.64002990722656,
        scaleX: 1,
      },
      squareWide: {
        y: 133.28379821777344,
        scaleX: 1,
      },
    },
  },

  {
    id: 'ChinSmallDoubleChin',
    svg: ChinSmallDoubleChin,
    positioning: {
      pointNarrow: {
        y: 140.43475341796875,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 136.75091552734375,
        scaleX: 1,
      },
      pointWide: {
        y: 137.2271728515625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 138.8759765625,
        scaleX: 1,
      },
      roundMedium: {
        y: 138.7756805419922,
        scaleX: 1,
      },
      roundWide: {
        y: 139.3623809814453,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 138.5472869873047,
        scaleX: 1,
      },
      squareMedium: {
        y: 138.63999938964844,
        scaleX: 1,
      },
      squareWide: {
        y: 137.4954833984375,
        scaleX: 1.15,
      },
    },
  },

  {
    id: 'ChinVertLine',
    svg: ChinVertLine,
    positioning: {
      pointNarrow: {
        y: 139.92283630371094,
        scaleX: 1,
      },
      pointMedium: {
        y: 138.7004852294922,
        scaleX: 1,
      },
      pointWide: {
        y: 137.7769775390625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 138.5406494140625,
        scaleX: 1,
      },
      roundMedium: {
        y: 138.57373046875,
        scaleX: 1,
      },
      roundWide: {
        y: 138.13955688476562,
        scaleX: 1,
      },
      squareNarrow: {
        y: 137.36199951171875,
        scaleX: 1,
      },
      squareMedium: {
        y: 137.87753295898438,
        scaleX: 1,
      },
      squareWide: {
        y: 138.49339294433594,
        scaleX: 1,
      },
    },
  },
]

export default data
